var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"captcha",attrs:{"src":_vm.captchaImg,"alt":"cpatcha"},on:{"click":_vm.loadSeccode}})
}
var staticRenderFns = []

export { render, staticRenderFns }